import { render, staticRenderFns } from "./MAM-vistaInicio.vue?vue&type=template&id=1f9e427e&scoped=true&"
import script from "./MAM-vistaInicio.vue?vue&type=script&lang=js&"
export * from "./MAM-vistaInicio.vue?vue&type=script&lang=js&"
import style0 from "./MAM-vistaInicio.vue?vue&type=style&index=0&id=1f9e427e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f9e427e",
  null
  
)

export default component.exports